import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { Rtmp } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    response: [] as Rtmp.Get.RtmpDestination[],
    url: `${CENTRAL_API_V3}/customers/@customerId/rtmp/destination`,
  },
  [HTTP_METHODS.POST]: {
    method: HTTP_METHODS.POST,
    request: {} as Rtmp.Post.RtmpDestination,
    url: `${CENTRAL_API_V3}/customers/@customerId/rtmp/destination`,
  },
};

export const id = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    params: {} as { id: string },
    response: {} as Rtmp.Get.RtmpDestination,
    url: `${CENTRAL_API_V3}/customers/@customerId/rtmp/destination/@id`,
  },
  [HTTP_METHODS.DELETE]: {
    method: HTTP_METHODS.DELETE,
    params: {} as { id: string },
    url: `${CENTRAL_API_V3}/customers/@customerId/rtmp/destination/@id`,
  },
  [HTTP_METHODS.PUT]: {
    method: HTTP_METHODS.PUT,
    params: {} as { id: string },
    request: {} as Rtmp.Put.RtmpDestination,
    url: `${CENTRAL_API_V3}/customers/@customerId/rtmp/destination/@id`,
  },
};
